"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Quote, Star } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VoicesOfRecovery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const testimonials = [{
    author: "Paivm",
    quote: "I'm very thankful to Dr Zanos. I came as I did not feel my leg from knee to foot. After 3 sessions I started to feel my leg and to feel good myself.",
    position: "Google review · Sep 2026",
    avatar: "",
    rating: 5
  }, {
    author: "Pablo M.",
    quote: "I work out and hike/run quite a lot. Have received amazing care at Bodywerks. It has helped me a lot keeping my body aligned and out of trouble.",
    position: "Google review · Sep 2026",
    avatar: "",
    rating: 5
  }, {
    author: "Thaer J.",
    quote: "I've been having problems with sciatica to the point where I was not able to walk. 2 sessions later I saw an improvement I didn't think was possible.",
    position: "Google review · Aug 2024",
    avatar: "",
    rating: 5
  }, {
    author: "C M.",
    quote: "Months of physiotherapy can't even start solving the problem of what just a session at this chiropractor can.",
    position: "Google review",
    avatar: "",
    rating: 5
  }];
  return <section data-section-id="19632" id="patient-journeys" ref={ref} className={`bg-background text-foreground py-24 px-4 overflow-hidden transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-3xl md:text-5xl font-serif font-medium tracking-tight text-primary">
            Patient Journeys
          </h2>
          <p className="text-secondary max-w-2xl mx-auto text-lg font-sans">
            Rated 4.9★ from 113 reviews on Google. Real stories from our patients in Limassol and Nicosia.
          </p>
        </div>

        <Carousel opts={{
        align: "center",
        loop: true
      }} className="w-full relative">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={i} className="md:basis-full lg:basis-full">
                <div className="p-4" data-index={i}>
                  <div className="flex flex-col items-center text-center space-y-8">
                    {}
                    <div className="relative">
                      <Quote className="w-16 h-16 text-accent opacity-60 rotate-180" strokeWidth={1.5} />
                    </div>

                    {}
                    <div className="flex gap-1">
                      {[...Array(testimonial.rating)].map((_, starIndex) => <Star key={starIndex} data-index={starIndex} className="w-5 h-5 fill-accent text-accent" />)}
                    </div>

                    {}
                    <blockquote className="text-xl md:text-3xl font-medium leading-relaxed max-w-3xl text-primary/90 font-serif italic">
                      &ldquo;{testimonial.quote}&rdquo;
                    </blockquote>

                    {}
                    <div className="flex flex-col items-center gap-3 pt-4">
                      <SafeHydrate><Avatar className="w-16 h-16 border-2 border-accent/20 shadow-md">
                        <AvatarImage src={testimonial.avatar} alt={testimonial.author} className="object-cover" />
                        <AvatarFallback className="bg-muted text-secondary text-lg font-sans">
                          {testimonial.author.charAt(0)}
                        </AvatarFallback>
                      </Avatar></SafeHydrate>
                      <div className="space-y-1">
                        <div className="font-semibold text-lg text-primary font-sans">
                          {testimonial.author}
                        </div>
                        <div className="text-sm text-secondary uppercase tracking-widest font-medium font-sans">
                          {testimonial.position}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="hidden md:block">
            <CarouselPrevious className="left-0 -translate-x-12 lg:-translate-x-24 border-accent hover:bg-accent/10 hover:text-accent text-accent transition-all duration-300" />
            <CarouselNext className="right-0 translate-x-12 lg:translate-x-24 border-accent hover:bg-accent/10 hover:text-accent text-accent transition-all duration-300" />
          </div>
        </Carousel>
      </div>
    </section>;
}